import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { AddDivision$Params } from 'src/api/generated/fn/divisions/add-division';
import { UpdateDivision$Params } from 'src/api/generated/fn/divisions/update-division';
import { GetInventories$Params } from 'src/api/generated/fn/inventory/get-inventories';
import { AddDivisionDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Divisions/add-division-dto';
import { UpdateDivisionDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Divisions/update-division-dto';
import { InventoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';
import { DivisionDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/division-dto';
import { DivisionsService, InventoryService } from 'src/api/generated/services';

@Component({
  selector: 'app-add-or-edit-division',
  templateUrl: './add-or-edit-division.component.html',
  styleUrls: ['./add-or-edit-division.component.scss']
})
export class AddOrEditDivisionComponentV2 implements OnInit {

  public venueId: string;
  public inventoryId: string;
  public unsubscribe: Subject<void> = new Subject<void>();
  public editFlag: boolean = false;
  public divisionId: string;
  public inventories: Array<InventoryDto> = new Array<InventoryDto>();
  public division: DivisionDto = {} as DivisionDto;

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private divisionsService: DivisionsService,
    private inventoryService: InventoryService
  ) {

    if (this.config.data != undefined) {
      this.division.inventory = {} as InventoryDto;
      if (this.config.data.item) {
        this.division.name = this.config.data.item.name;
        this.division.printerAddress = this.config.data.item.printerAddress;
        this.venueId = this.config.data.venueId;
        this.division.inventory = this.config.data.item.inventory;
        this.divisionId = this.config.data.item.id;
        this.editFlag = true;
      }
      if (this.config.data.venueId) {
        this.venueId = this.config.data.venueId;
      }
    }
  }

  ngOnInit(): void {
    this.getInventoriesForVenue();
  }

  getInventoriesForVenue() {
    var params: GetInventories$Params = {} as GetInventories$Params;
    params.venueId = this.venueId;
    params.isRemoved = false;
    this.inventoryService.getInventories(params)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          if (response.inventories) {
            this.inventories = response.inventories;
          }
        },
        error: errorResponse => {
        }
      });
  }

  addDivision(f: NgForm) {
    if(f.valid){
      var params: AddDivision$Params = {} as AddDivision$Params;
      const addDivisionDto: AddDivisionDto = { inventoryId: this.division.inventory?.id, venueId: this.venueId, printerAddress: this.division.printerAddress, name: this.division.name };
      params.body = addDivisionDto;
      this.divisionsService.addDivision(params)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.ref.close(true)
          },
          error: errorResponse => {
          }
        });
    }
  }

  editDivision(f: NgForm) {
      if(f.valid){
        var params: UpdateDivision$Params = {} as UpdateDivision$Params;
        params.divisionId = this.divisionId;
        const updateDivision: UpdateDivisionDto = { inventoryId: this.division.inventory?.id, venueId: this.venueId, printerAddress: this.division.printerAddress, name: this.division.name };
        params.body = updateDivision;
        this.divisionsService.updateDivision(params)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: (response) => {
              this.ref.close(true)
            },
            error: errorResponse => {
            }
          });
      }
  }
  

  close() {
    this.ref.close(null);
  }
}

